import React, { useState } from "react";
import { GiCheckMark } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { setFamilyMembers } from "store/actions/Profile/profile";
import { FaChildren, FaPersonHalfDress } from "react-icons/fa6";
import { MdOutlinePets } from "react-icons/md";
import { FaPeopleArrows } from "react-icons/fa";
import { useNavigate } from "react-router";
import { showToast } from "utils/showToast";

const GridItem = ({ icon, label, status, onClick, selectedStore }) => (
  <div
    style={{
      borderColor: status ? selectedStore?.theme.backgroundColor : "",
    }}
    className={`relative z-30 cursor-pointer flex items-center justify-center h-32 bg-gray-300 border rounded-md ${
      status ? "shadow-lg border-theme-color bg-gray-400" : ""
    }`}
    onClick={onClick}
  >
    <div
      style={{
        color: status ? selectedStore?.theme.backgroundColor : "",
      }}
      className={`flex flex-col items-center justify-center ${
        status ? "text-theme-color" : "text-black"
      }`}
    >
      {icon}
      <div>{label}</div>
    </div>
    {status && (
      <div
        style={{
          backgroundColor: selectedStore?.theme.backgroundColor,
        }}
        className="absolute flex items-center justify-center w-10 h-10 text-center rounded-full bottom-1 right-1"
      >
        <GiCheckMark className="text-white" />
      </div>
    )}
  </div>
);
export const Preferences = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { user } = useSelector((store) => store.userReducer);

  const [status, setStatus] = useState({
    single: false,
    married: false,
    kids: false,
    pets: false,
  });

  const handleToggle = (field) => {
    if (field === "single") {
      setStatus({ ...status, single: true, married: false });
    } else if (field === "married") {
      setStatus({ ...status, married: true, single: false });
    } else {
      setStatus({ ...status, [field]: !status[field] });
    }
  };
  const familyMembers = (isSingle, isMarried, hasKids, hasPets) => {
    dispatch(
      setFamilyMembers({
        single: isSingle,
        married: isMarried,
        kids: hasKids,
        pets: hasPets,
      })
    );
  };
  const calculateFamilyMembers = () => {
    let count = 0;
    if (status.single) {
      count++;
      familyMembers(true, false, false, false);
    }
    if (status.married) {
      count = 2;
      familyMembers(false, true, false, false);
    }
    if (status.kids && status.single) {
      count++;
      familyMembers(true, false, true, false);
    }
    if (status.kids && status.married) {
      count = 3;
      familyMembers(false, true, true, false);
    }
    if (status.pets && status.single) {
      count = 2;
      familyMembers(true, false, false, true);
    }
    if (status.pets && status.married) {
      count++;
      familyMembers(false, true, false, true);
    }
    if (status.pets && status.married && status.kids) {
      count = 4;
      familyMembers(false, true, true, true);
    }
    if (status.pets && status.single && status.kids) {
      count = 3;
      familyMembers(true, false, true, true);
    }
    return count;
  };

  const getFamilyMemberText = () => {
    const count = calculateFamilyMembers();
    if (count === 1) {
      return "Family member: 1";
    } else if (count === 2) {
      return "Family members: 2";
    } else if (count === 3) {
      return "Family members: 3+";
    } else if (count === 4) {
      return "Family members: 4+";
    } else {
      return "";
    }
  };
  return (
    <div className="flex flex-col justify-center flex-grow min-h-screen align-center gap-7">
      <div className="mt-4 text-3xl text-center">
        <h3>Customize your grocery savings!</h3>
      </div>
      <div className="p-8 ml-auto mr-auto bg-gray-100 rounded-lg shadow-lg lg:w-2/5 h-96">
        <h1 className="mb-4 text-center ">
          How many family members do you have?
        </h1>
        <div className="grid grid-cols-2 gap-4">
          <GridItem
            icon={<FaPersonHalfDress size={30} />}
            label="Single"
            status={status.single}
            onClick={() => handleToggle("single")}
            selectedStore={selectedStore}
          />
          <GridItem
            icon={<FaPeopleArrows size={30} />}
            label="Married"
            status={status.married}
            onClick={() => handleToggle("married")}
            selectedStore={selectedStore}
          />
          <GridItem
            icon={<FaChildren size={30} />}
            label="Kids"
            status={status.kids}
            onClick={() => handleToggle("kids")}
            selectedStore={selectedStore}
          />
          <GridItem
            icon={<MdOutlinePets size={30} />}
            label="Pets"
            status={status.pets}
            onClick={() => handleToggle("pets")}
            selectedStore={selectedStore}
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-2 ">
        <div>{getFamilyMemberText()}</div>
        <div className="flex gap-4">
          <button
            onClick={() => {
              if (!status.single && !status.married) {
                showToast("Please select your marital status", "error", true);
              } else if (
                (status.single && (status.kids || status.pets)) ||
                (status.married && (status.kids || status.pets))
              ) {
                navigate(`/users/${user.data.id}/onBoarding`);
              } else {
                navigate(`/stores/${selectedStore?.id}/dashboard`);
              }
            }}
            style={{
              backgroundColor: selectedStore?.theme.backgroundColor,
            }}
            className="w-24 px-3 py-1 text-white rounded-md hover:bg-lighterPurple"
          >
            Proceed
          </button>
          <button
            onClick={() => navigate(`/stores/${selectedStore?.id}/dashboard`)}
            style={{
              backgroundColor: selectedStore?.theme.backgroundColor,
            }}
            className="w-24 px-3 py-1 text-center text-white rounded-md hover:bg-lighterPurple"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};
